import ErroQuestionarioSecao from './ErroQuestionarioSecao';

/**
 * Objeto para armazenar as mensagens de erro do questionário
 */
class ErroQuestionario {

    /**
     * Cria uma nova instância da lista de erros do questionário
     * Caso os parâmetros não sejam informados, cria com valores padrão
     * 
     * @param {Boolean} valido Indica se o objeto é valido ou não
     * @param {String} erroQuestionario Mensagem de erro geral do objeto
     * @param {String} titulo Mensagem de erro para o título
     * @param {String} empresa Mensagem de erro para a empresa
     * @param {String} modelo Mensagem de erro para o campo modelo
     * @param {String} exibeCliente Mensagem de erro para o campo exibeCliente
     * @param {String} status Mensagem de erro para o status
     * @param {String} erroSecoes Mensagem de erro relativo a lista de seções
     * @param {Array<ErroQuestionarioSecao>} secoes Lista com os erros das seções
     */
    constructor(valido, erroQuestionario, titulo, empresa, modelo, exibeCliente, status, erroSecoes, secoes) {
        /** @member {Boolean} valido Indica se o objeto é valido ou não */
        this.valido = valido ?? true;
        /** @member {String} erroQuestionario Mensagem de erro geral do objeto */
        this.erroQuestionario = erroQuestionario ?? '';
        /** @member {String} titulo Mensagem de erro para o título */
        this.titulo = titulo ?? '';
        /** @member {String} empresa Mensagem de erro para a empresa */
        this.empresa = empresa ?? '';
        /** @member {String} modelo Mensagem de erro para o campo modelo */
        this.modelo = modelo ?? '';
        /** @member {String} exibeCliente Mensagem de erro para o campo exibeCliente */
        this.exibeCliente = exibeCliente ?? '';
        /** @member {String} status Mensagem de erro para o status */
        this.status = status ?? '';
        /** @member {String} erroSecoes Mensagem de erro relativo a lista de seções */
        this.erroSecoes = erroSecoes ?? '';
        /** @member {Array<ErroQuestionarioSecao>} secoes Lista com os erros das seções */
        this.secoes = secoes ?? [];
    }

    /**
     * Verifica se dois objetos possuem os mesmos valores
     * @param {ErroQuestionario} obj1 Primeiro objeto a ser comparado
     * @param {ErroQuestionario} obj2 Segundo objeto a ser comparado
     * @returns {Boolean} Retorna verdadeiro se os dois objetos forem iguais
     */
    static compare(obj1, obj2) {
        //Se os dois possuírem o mesmo endereço de memória
        if (obj1 === obj2)
            return true;
        //Se um dos dois for nulo
        if (!obj1 || !obj2)
            return false;
        //Compara as propriedades
        let result = obj1.valido === obj2.valido
                  && obj1.erroQuestionario === obj2.erroQuestionario
                  && obj1.titulo === obj2.titulo
                  && obj1.empresa === obj2.empresa
                  && obj1.modelo === obj2.modelo
                  && obj1.exibeCliente === obj2.exibeCliente
                  && obj1.status === obj2.status
                  && obj1.erroSecoes === obj2.erroSecoes;

        //Caso as propriedades sejam iguais, verifica as listas
        if (result) {
            return ErroQuestionario.compareQuestoes(obj1.secoes, obj2.secoes);
        } else {
            return false;
        }
    }

    /**
     * Compara a lista de erros das seções
     * @param {Array<ErroQuestionarioSecao>} list1 Lista de erro das seções do primeiro objeto
     * @param {Array<ErroQuestionarioSecao>} list2 Lista de erro das seções do segundo objeto
     * @returns {Boolean} Retorna verdadeiro se os itens das duas listas são iguais
     */
    static compareQuestoes(list1, list2) {
        //Se as duas listas possuírem o mesmo endereço de memória
        if (list1 === list2)
            return true;
        //Se uma das duas for nula
        if (!list1 || !list2)
            return false;
        //Se os tamanhos forem diferentes
        if (list1.length !== list2.length)
            return false;
        //Verifica se existe algum item que seja diferente entre as listas
        for (let i = 0; i < list1.length; i++) {
            if (!ErroQuestionarioSecao.compare(list1[i], list2[i]))
                return false;
        }
        return true;
    }
}

export default ErroQuestionario;